module.exports = __webpack_public_path__ + "static/img/34.f01c35f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/34.png
// module id = il7d
// module chunks = 1